/**
 * Created by desheng.zhao on 2018/6/13.
 */
var date = function(timestamp,sep='-'){
    var _date = new Date(timestamp);
    var y = _date.getFullYear();
    var m = _date.getMonth()+1;
    var d = _date.getDate();
    return "" + y + sep + doubleNum(m) + sep +  doubleNum(d);
}
 var doubleNum = function (n) {
     if(n.length>2 || n>100){
         return n;
     }
     n = parseInt(n);
     return n>=10 ? "" + n : "0" + n;
 }

 var time = function (timestamp, sep=":") {
     var _date = new Date(timestamp);
     var h = _date.getHours();
     var m = _date.getMinutes();
     var s = _date.getSeconds();
     return doubleNum(h) + sep + doubleNum(m) + sep +  doubleNum(s);
 }

 var dateTime = function (timestamp, dateSep="-", timeSep=":") {
     return date(timestamp, dateSep) + " " + time(timestamp, timeSep);
 }
module.exports = {
    date,
    time,
    dateTime,
    doubleNum
}


// WEBPACK FOOTER //
// ./src/filters/date.js